<div class="kanban-board">
    <div class="kanban-column" *ngFor="let col of columns">
        <div class="kanban-column__header" [attr.data-status]="col.status.toLowerCase()">
            <div class="column-title">
                <i [class]="col.icon"></i>
                <span>{{ col.label }}</span>
            </div>
            <span class="column-count">{{ col.clients.length }}</span>
        </div>

        <div
            class="kanban-column__body"
            cdkDropList
            [id]="getColumnId(col.status)"
            [cdkDropListData]="col.clients"
            [cdkDropListConnectedTo]="connectedLists"
            (cdkDropListDropped)="onDrop($event, col.status)"
        >
            <div
                class="kanban-card"
                *ngFor="let client of col.clients"
                cdkDrag
                [cdkDragStartDelay]="0"
                [attr.data-status]="col.status.toLowerCase()"
                [class.starred]="client.isStarred"
                (click)="leadClicked.emit(client)"
            >
                <button class="card-star-btn" [class.starred]="client.isStarred"
                    (click)="starToggled.emit(client); $event.stopPropagation()">
                    <i [class]="client.isStarred ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
                </button>

                <div class="kanban-card__top">
                    <div class="card-avatar" [style.background-color]="getInitialColor(client)">
                        <img *ngIf="getAvatarUrl(client)" [src]="getAvatarUrl(client)" alt="" />
                        <span class="card-avatar__initials">{{ getInitials(client) }}</span>
                    </div>
                    <div class="card-identity">
                        <ng-container *ngIf="hasRealCompany(client); else privateCard">
                            <div class="kanban-card__name">
                                <span>{{ client.companyName }}</span>
                            </div>
                            <div class="kanban-card__subtitle">
                                {{ (client.firstName || 'No Name') + ' ' + (client.lastName || '') }}
                            </div>
                        </ng-container>
                        <ng-template #privateCard>
                            <div class="kanban-card__name">
                                <span>{{ (client.firstName || 'No Name') + ' ' + (client.lastName || '') }}</span>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <div class="kanban-card__details">
                    <span class="detail-item" *ngIf="client.broadLocation">
                        <i class="fa-solid fa-location-dot"></i> {{ client.broadLocation }}
                    </span>
                    <span class="detail-item" *ngIf="client.numberOfBays">
                        <i class="fa-solid fa-car"></i> {{ client.numberOfBays }} {{ client.numberOfBays === 1 ? 'bay' : 'bays' }}
                    </span>
                    <span class="detail-item" *ngIf="client.monthsRequired">
                        <i class="fa-solid fa-calendar"></i> {{ client.monthsRequired }} mo
                    </span>
                    <span *ngIf="client.numberOfBays" class="value-badge-sm"
                        [class.value-badge-sm--high]="getLeadValueTier(client) === 'HIGH'"
                        [class.value-badge-sm--medium]="getLeadValueTier(client) === 'MEDIUM'"
                        [class.value-badge-sm--low]="getLeadValueTier(client) === 'LOW'">
                        {{ getLeadValueTier(client) }}
                    </span>
                </div>

                <div class="kanban-card__footer">
                    <span class="touchpoint-badge" [style.color]="getTouchpointColor(client)">
                        <i class="fa-regular fa-clock"></i> {{ formatLastTouchpoint(client) }}
                    </span>
                    <span
                        *ngIf="getAssigneeName(client.userResponsible)"
                        class="assignee-badge"
                        [style.background-color]="getAssigneeColor(client.userResponsible)"
                    >
                        {{ getAssigneeName(client.userResponsible) }}
                    </span>
                </div>

                <div class="kanban-card__note" *ngIf="client.latestComment?.text">
                    <i class="fa-solid fa-comment"></i>
                    <span>{{ client.latestComment?.text | slice: 0:60 }}{{ (client.latestComment?.text?.length || 0) > 60 ? '...' : '' }}</span>
                </div>
            </div>

            <div class="kanban-empty" *ngIf="col.clients.length === 0">
                <i class="fa-regular fa-rectangle-list"></i>
                <span>No leads</span>
            </div>
        </div>
    </div>
</div>
